(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-components/assets/javascripts/participant.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-components/assets/javascripts/participant.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useMemo = _React.useMemo;
const Coupon = svs.components.tipsen.couponComponents.Coupon;
const _svs$components$lbUi$ = svs.components.lbUi.participants,
  SmartAbbr = _svs$components$lbUi$.SmartAbbr,
  _svs$components$lbUi$2 = _svs$components$lbUi$.constants,
  getTeamName = _svs$components$lbUi$2.getTeamName,
  DescriptionSize = _svs$components$lbUi$2.DescriptionSize;
const getTeamNameAndTitle = (participant, nameSize) => {
  const name = getTeamName(participant, nameSize);
  const title = (participant === null || participant === void 0 ? void 0 : participant.name) || name;
  return [name, title];
};
const Participant = _ref => {
  let _ref$nameSize = _ref.nameSize,
    nameSize = _ref$nameSize === void 0 ? DescriptionSize.Medium : _ref$nameSize,
    participant = _ref.participant;
  const _useMemo = useMemo(() => getTeamNameAndTitle(participant, nameSize), [participant, nameSize]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    teamName = _useMemo2[0],
    teamTitle = _useMemo2[1];
  return React.createElement(SmartAbbr, {
    title: teamTitle
  }, teamName);
};
Coupon.Participant = Participant;

 })(window);